interface DiffLine {
  type: 'add' | 'remove' | 'context';
  content: string;
}

interface DiffHunk {
  oldStart: number;
  oldLines: number;
  newStart: number;
  newLines: number;
  lines: DiffLine[];
}

interface Props {
  hunks: DiffHunk[];
  stats: { added: number; removed: number };
  baseBranch: string;
  /** When set, the diff is from a past commit rather than the working tree */
  lastCommitRef?: string;
}

export function DiffView({ hunks, stats, baseBranch, lastCommitRef }: Props) {
  return (
    <div class="diff-view">
      <div class="diff-stats">
        <span class="diff-stat-add">+{stats.added}</span>
        {' '}
        <span class="diff-stat-remove">-{stats.removed}</span>
        {' '}
        <span class="diff-stat-base">
          {lastCommitRef ? `last commit: ${lastCommitRef}` : `vs ${baseBranch}`}
        </span>
      </div>
      <table class="diff-table">
        <tbody>
          {hunks.map((hunk, hi) => {
            let oldLine = hunk.oldStart;
            let newLine = hunk.newStart;
            return (
              <>
                <tr key={`hunk-${hi}`} class="diff-hunk-header">
                  <td class="diff-gutter diff-gutter-old" />
                  <td class="diff-gutter diff-gutter-new" />
                  <td class="diff-code diff-hunk-label">
                    @@ -{hunk.oldStart},{hunk.oldLines} +{hunk.newStart},{hunk.newLines} @@
                  </td>
                </tr>
                {hunk.lines.map((line, li) => {
                  const oldNum = line.type !== 'add' ? oldLine : null;
                  const newNum = line.type !== 'remove' ? newLine : null;
                  if (line.type !== 'add') oldLine++;
                  if (line.type !== 'remove') newLine++;
                  return (
                    <tr key={`${hi}-${li}`} class={`diff-line diff-line--${line.type}`}>
                      <td class="diff-gutter diff-gutter-old">{oldNum ?? ''}</td>
                      <td class="diff-gutter diff-gutter-new">{newNum ?? ''}</td>
                      <td class="diff-code">
                        <pre><code>{line.type === 'add' ? '+' : line.type === 'remove' ? '-' : ' '}{line.content}</code></pre>
                      </td>
                    </tr>
                  );
                })}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
